import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api, endpoints } from '../api/client';

export interface FogSettings {
  fogBaseUrl: string;
  fogApiToken: string;
  fogUserToken: string;
  hasApiToken: boolean;
  hasUserToken: boolean;
}

export interface FogSettingsInput {
  fogBaseUrl?: string;
  fogApiToken?: string;
  fogUserToken?: string;
}

export interface FogTestResult {
  success: boolean;
  message?: string;
  error?: string;
  fogVersion?: string;
  hostCount?: number;
}

export interface FogUpdateResult {
  success: boolean;
  message: string;
  updated: string[];
}

export function useFogSettings() {
  return useQuery({
    queryKey: ['settings', 'fog'],
    queryFn: async () => {
      return api.get<FogSettings>(endpoints.settings.fog);
    },
  });
}

export function useUpdateFogSettings() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (settings: FogSettingsInput) => {
      return api.put<FogUpdateResult>(endpoints.settings.fog, settings);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['settings', 'fog'] });
    },
  });
}

export function useTestFogConnection() {
  return useMutation({
    mutationFn: async (settings?: FogSettingsInput) => {
      return api.post<FogTestResult>(endpoints.settings.fogTest, settings || {});
    },
  });
}
